import { atom } from "recoil"

export const defaultListIdState = atom<string>({
  key: "defaultListId",
  default: "",
})
